import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

// Helpers de formulário
import InputMask from 'react-input-mask';

class MatterSubjectsTab extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      matter_id: null,
      subject: null,
      tenor_name: null,
      tenor: null,
      hours: null,
      dados: [],
    };
    this.botaoAcoes = this.botaoAcoes.bind(this);
    this.adicionarAssunto = this.adicionarAssunto.bind(this);
    this.deletar = this.deletar.bind(this);
    this.deletarLinha = this.deletarLinha.bind(this);
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 

  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.assuntos)) {
      this.setState({dados: newProps.assuntos});
    }
  }  

  adicionarAssunto(event) {
    event.preventDefault();
    var datasave = {
      matter_id: this.props.matter_id,
      subject: this.state.subject,
      tenor_name: this.state.tenor_name,
      tenor: this.state.tenor,
      hours: this.state.hours,
    };
    var header = this.refs.request_api.header('application/json');
    this.props.handleAlert('', '', 'open');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/materia/assunto', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var dados_temp = self.state.dados;
          dados_temp.push(responseJson.data);
          self.setState({dados: dados_temp});
        }
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  botaoAcoes (cell, row, enumObject, index) {
    var variavel = (
      /*<botaoAcoes url={"/materia/assunto/"+ cell} />*/
      <button className="btn btn-sm btn-danger" value={row.id} onClick={this.deletar}>
        <i className="fa fa-fw fa-trash"></i>
      </button>
    );

    return variavel;
  }

  deletar (event) {
    var matter_subject_id = event.currentTarget.value;
    var confirm = window.confirm('Tem certeza que gostaria de deletar essa assunto?');
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/materia/assunto/' + matter_subject_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deletarLinha(matter_subject_id);
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  deletarLinha(matter_subject_id) {
    var dados = this.state.dados;
    dados.map(function(dado, index){
      if (dado.id == matter_subject_id) {
        dados.splice(index, 1);
      }
    });
    this.setState({dados: dados});
  }

  render() {
    return (
<div>
  <RequestApi ref={'request_api'} />
  <form onSubmit={this.adicionarAssunto}> 
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>Assunto:</label>
          <input type="text" name="subject" className="form-control" placeholder="Assunto" value={this.state.subject} onChange={this.handleChange.bind(this, 'subject')} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>Nome do conteúdo:</label>
          <input type="text" name="tenor_name" className="form-control" placeholder="Nome do conteúdo" value={this.state.tenor_name} onChange={this.handleChange.bind(this, 'tenor_name')} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>Conteúdo:</label>
          <input type="text" name="tenor" className="form-control" placeholder="Conteúdo" value={this.state.tenor} onChange={this.handleChange.bind(this, 'tenor')} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>Carga horária:</label>
          <InputMask value={this.state.hours}  maskChar={null} name="hours" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'hours')} placeholder="Informe a carga horária no formato hh:mm" />
        </div>
      </div>
    </div>
    <button type="submit" className="btn btn-primary btn-inline btn-block"><i className="fa fa-fw fa-save"></i> Adicionar assunto</button>
  </form>
  <hr/>
  <BootstrapTable data={this.state.dados} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', sizePerPage: 100, noDataText: 'Não há assuntos cadastrados'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

    <TableHeaderColumn isKey={true} dataField="subject" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Assunto</TableHeaderColumn>
    <TableHeaderColumn dataField="tenor_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Nome do conteúdo</TableHeaderColumn>
    <TableHeaderColumn dataField="tenor" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Conteúdo</TableHeaderColumn>
    <TableHeaderColumn dataField="hours" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Carga horária</TableHeaderColumn>

    <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.botaoAcoes} width='80'>Ações</TableHeaderColumn>

  </BootstrapTable>
</div>
    );
  }
}

export default MatterSubjectsTab;



// WEBPACK FOOTER //
// ./src/Components/Matters/Elements/MatterSubjectsTab.js